import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const ClientPortal = lazy(() => import('../pages/client-portal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/faq',
    element: <FAQ />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/resources',
    element: <Resources />
  },
  {
    path: '/client-portal',
    element: <ClientPortal />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
